import React, { useEffect, useState } from 'react';
import { Menu } from '../_Menu';
import Pagger from '../components/_Pagger';
import Header from '../Header';
import { Popover, Select } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faMagnifyingGlass, faWrench } from '@fortawesome/free-solid-svg-icons';
import { CustomerCardModel } from '../models/CustomerCardModel';
import PleaseWaitLayer from '../components/_PleaseWaitLayer';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { SimulatorModel } from '../models/SimulatorModel';
import { LeadDocumentPopup } from '../leads/_LeadDocumentPopup';
import { ViewMode } from '../clients/enums';
import { OfferProductionModel } from '../models/OfferProductionModel';
import { SubscriberPopup } from '../subscribers/_SubscriberPopup';
import { ElementaryPolicyStatusModel } from '../models/ElementaryPolicyStatus';
import { GeneralDataModel } from '../models/GeneralDataModel';
import { SuesModel } from '../models/SuesModel';
import SuesTable from './_SuesTable';
import AdvancedSuesSearch from './_AdvancedSuesSearch';
import SueDetails from './_SueDetails';
import { ManulApiModel } from '../models/ManulApiModel';
import SuesConfigPopup from './_SuesConfigPopup';
import ClientAddTreatmentPopup from '../clients/_ClientAddTreatmentPopup';
import { LeadMessagePopup } from '../leads/_LeadMessagePopup';
import { RootState } from '../app-context/store';
import { de, el } from 'date-fns/locale';
import { get } from 'lodash';
import { setFilterCleaned, setReloadSuesData } from '../app-context/suesSlice';
import { ClientPopup } from '../clients/_ClientPopup';
import AdvancedClientSuesFilter from './_AdvancedClientSuesFilter';


type Props = {
    showTabs: boolean;
    customerId?: string;
    onClaimEdit?: Function
};

const Sues = (props: Props) => {
    const customerCardModel: CustomerCardModel = new CustomerCardModel();
    const generalModel: GeneralDataModel = new GeneralDataModel();
    const simulatorModel: SimulatorModel = new SimulatorModel();
    const manulApiModel: ManulApiModel = new ManulApiModel();
    const offerProductionModel: OfferProductionModel = new OfferProductionModel();
    const elementaryPolicyStatusModel: ElementaryPolicyStatusModel = new ElementaryPolicyStatusModel();
    const suesModel = new SuesModel();

    const dispatch = useDispatch();

    const userLogged = useSelector((state: any) => state.user.value);
    const popUpTreatmentSuesModel = useSelector((state: RootState) => state.tasks.popUpTreatmentSuesModel)
    const reloadSuesData = useSelector((state: RootState) => state.sues.reloadSuesData)
    const filterCleaned = useSelector((state: RootState) => state.sues.filterCleaned);


    const [showAddTreatmentPopUp, setShowAddTreatmentPopUp] = useState<boolean>(false);
    const [suesFilter, setSuesFilter] = useState<any>({
        page: 1,
        customerId: props.customerId && props.customerId.length > 0 ? props.customerId : undefined
    });

    const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [documentUrl, setDocumentUrl] = useState<string | null>(null);
    const [openTabs, setOpenTabs] = useState<any[]>([]);
    const [sellectedSueId, setSellectedSueId] = useState<string | null>(null);
    const [selectedTabData, setSelectedTabData] = useState<any | null>(null);
    const [showOnlyRiders, setShowOnlyRiders] = useState<boolean>(false);

    const [currentUser, setCurrentUser] = useState<any | null>();

    const [creatorsOptions, setCreatorsOptions] = useState<any[]>([]);
    const [creatorsList, setCreatorsList] = useState<any[]>([]);
    const [usersOptions, setUsersOptions] = useState<any[]>([]);
    const [handlersList, setHandlersList] = useState<any[]>([]);
    const [sueStatuses, setSueStatuses] = useState<any[]>([]);
    const [sueActivityStatuses, setSueActivityStatuses] = useState<any[]>([]);
    const [sueTypes, setSueTypes] = useState<any[]>([]);
    const [sueApartmentTypes, setSueApartmentTypes] = useState<any[]>([]);

    const [productionTypes, setProductionTypes] = useState<any[]>([
        {
            label: 'בחר סוג הפקה',
            value: '-1'
        },
        {
            label: 'ידנית',
            value: '0'
        },
        {
            label: 'אוטומטית',
            value: '1'
        }])

    const [messageContent, setMessageContent] = useState<string | null>(null)

    const [suesList, setSuesList] = useState<any[] | null>([]);

    const [sortBy, setSortBy] = useState<any | undefined>(undefined);
    const [treatmentsSeachText, setTreatmentsSearchText] = useState<string>('');
    const [treatmentsTimeoutId, setTreatmentsTimeoutId] = useState<number | any | null>(undefined);

    const [newTreatmentType, setNewTreatmentType] = useState<number>(0);
    const [showSuesConfigPopUp, setShowSuesConfigPopUp] = useState<boolean>(false);
    const [showAddSubscriberPopUp, setShowAddSubscriberPopup] = useState<boolean>(false);
    const [showAssignToHandlerPopUp, setShowAssignToHandlerPopUp] = useState<boolean>(false);
    const [signingIdToAssign, setSigningIdToAssign] = useState<string | null>(null)
    const [selectedCustomer, setSelectedCustomer] = useState<any | null>(null)
    const [selectedVehicle, setSelectedVehicle] = useState<any | null>(null)
    const [showSigningConfigPopUp, setShowSigningConfigPopup] = useState<boolean>(false);

    const [assigmentStatuses, setAssignmentStatuses] = useState<any[]>([]);
    const [insuranceCompanyList, setInsuranceCompanyList] = useState<any[]>([]);
    const [selectedInsuranceCompany, setSelectedInsuranceCompany] = useState<string>('');

    const [garages, setGarages] = useState<any[]>([])

    const [agentsList, setAgentsList] = useState<any[]>([]);
    const [agents, setAgents] = useState<any[]>([])
    const [selectedAgent, setSelectedAgent] = useState<string>('0');
    const [selectedDateParam, setSelectedDateParam] = useState<string>('0');

    const [insuranceTypes, setInsuranceTypes] = useState<any[]>([]);
    const [vehicleOwnerships, setVehicleOwnership] = useState<any[]>([]);
    const [policyTypes, setPolicyTypes] = useState<any[]>([]);

    const [riderStatuses, setRiderStatuses] = useState<any[]>([]);

    const [currentPage, setCurrentPage] = useState<number>(1);

    const [filterCount, setFilterCount] = useState<string>('');
    const [selectedFilterOptions, setSelectedFilterOptions] = useState<any[]>([]);

    const [gendersList, setGendersList] = useState<any[]>([]);
    const [policyStatuses, setPolicyStatuses] = useState<any[]>([]);
    const [lastUpdate, setLastUpdate] = useState<Date | null>(null)

    const [sellectedCustomerId, setSellectedCustomerId] = useState<string | null>(null);

    const [pagerConf, setPagerConf] = useState<any>({
        pageSize: 50,
        currentPage: 0,
        totalItems: 0
    });
    const [licenseTypes, setLicenseTypes] = useState<any[]>([]);


    const [showPopUp, setShowPopup] = useState<boolean>(false);
    const [popUptitle, setPopUpTitle] = useState<string>('');

    const init = () => {

        const lastSuesFilter = localStorage.getItem('lastSuesFilter');
        if (!lastSuesFilter) {
            const filter: any = { ...suesFilter };
            if (!props.customerId) {
                filter.customerId = undefined;
            } else {
                filter.searchTerm = undefined;
                filter.customerId = props.customerId;
                // setSellectedCustomerId(props.customerId);
            }
            setSuesFilter(filter);
            localStorage.setItem('lastSuesFilter', JSON.stringify({ ...filter }));
            // if (insuranceCompanyList && insuranceCompanyList.length > 0)
            //     getSues();
        } else {
            const filterStorage = JSON.parse(lastSuesFilter);
            if (!props.customerId) {
                console.log('filterStorage-!props.customerId')
                filterStorage.customerId = undefined;
                if (filterStorage.searchTerm && filterStorage.searchTerm.length > 0) {
                    console.log('filterStorage.searchTerm', filterStorage.searchTerm)
                    setTreatmentsSearchText(filterStorage.searchTerm);
                }
                localStorage.setItem('lastSuesFilter', JSON.stringify({ ...filterStorage }));
                setSuesFilter(filterStorage);
            } else if (props.customerId) {
                // filterStorage.searchTerm = undefined;
                // filterStorage.customerId = props.customerId;
                let customerFilter = {
                    page: 1,
                    customerId: props.customerId
                }
                setSuesFilter(customerFilter);
            }
            // getSues(filter);
        }

        getComboData();
    }

    const getComboData = async () => {

        const usersData = await generalModel.customerCardGetCreators();
        setUsersOptions(usersData);

        const insuranceTypesList: any[] = [];
        const insuranceTypesData = await generalModel.getAppDictionaryListExpanded();
        const itTempDataKeys = Object.keys(insuranceTypesData);
        itTempDataKeys.forEach((k: string) => {
            insuranceTypesList.push({
                value: insuranceTypesData[k].id,
                label: insuranceTypesData[k].description,
                id: insuranceTypesData[k].id,
                name: insuranceTypesData[k].description,
            })
        });
        setInsuranceTypes(insuranceTypesList);
        localStorage.setItem('insuranceTypes', JSON.stringify(insuranceTypesList));

        // get license types list
        const licenseTypesList: any[] = [];
        // let firstElement = {
        //     value: -1,
        //     label: 'בחר סוג רשיון',
        //     id: -1,
        //     name: 'בחר סוג רשיון',
        // }
        // licenseTypesList.push(firstElement);
        const licenseTypesData = await generalModel.getLicenseTypes();
        const ltTempDataKeys = Object.keys(licenseTypesData);
        ltTempDataKeys.forEach((k: string) => {
            licenseTypesList.push({
                value: licenseTypesData[k].id,
                label: licenseTypesData[k].description,
            })
        });

        setLicenseTypes(licenseTypesList);
        localStorage.setItem('licenseTypes', JSON.stringify(licenseTypesList));


        // const riderStatusesList: any[] = [];
        // const riderStatusesData = await generalModel.getRiderStatuses();
        // const riderStatusesTempDataKeys = Object.keys(riderStatusesData);
        // riderStatusesTempDataKeys.forEach((k: string) => {
        //     const item = {
        //         id: riderStatusesData[k].id,
        //         name: riderStatusesData[k].description,
        //         nameEng: riderStatusesData[k].name,
        //     };
        //     riderStatusesList.push(item);
        // });
        // setRiderStatuses(riderStatusesList);

        const vehicleOwnershipList: any[] = [];
        const vehicleOwnershipData = await simulatorModel.getVehicleOwnership();
        const sTempDataKeys = Object.keys(vehicleOwnershipData);
        sTempDataKeys.forEach((k: string) => {
            vehicleOwnershipList.push({
                value: vehicleOwnershipData[k].id,
                label: vehicleOwnershipData[k].description,
                id: vehicleOwnershipData[k].id,
                name: vehicleOwnershipData[k].description,
            })
        });
        setVehicleOwnership(vehicleOwnershipList)


        const vehiclePolicyTypes = await suesModel.getVehiclePolicyTypes()
        setPolicyTypes(vehiclePolicyTypes.map((vpt: any) => {
            return {
                value: vpt.id.toString(),
                label: vpt.name,
                id: vpt.id.toString(),
                name: vpt.name,
            }
        }));

        const creatorsList = localStorage.getItem('creatorsList');
        if (creatorsList) {
            const dataList = buildOptionsForSelect(JSON.parse(creatorsList), 'id', 'כל היוצרים');
            setCreatorsOptions(dataList)
            const newCreatorsList: any = [
                {
                    label: 'נוצר ע"י',
                    value: '-1'
                },
                {
                    label: 'יוזרים פעילים',
                    value: '0'
                },
                {
                    label: 'יוזרים לא פעילים',
                    value: '1'
                },
                {
                    label: 'כל היוזרים',
                    value: '2'
                },
                ...dataList
            ]
            setCreatorsList(newCreatorsList)
        }

        const handlersData = await generalModel.getClaimHandlers();
        if (handlersData) {
            setHandlersList(handlersData.map((h: any) => {
                return {
                    label: h.fullName,
                    value: h.id
                }
            }))
        }
        // setHandlersList

        simulatorModel.getGenderTypes().then((res: any) => {
            const gendersList: any = [];
            Object.keys(res).forEach((key: string) => {
                const gender = res[key];
                gendersList.push({
                    label: gender.description,
                    value: gender.id.toString()
                })
            })
            setGendersList(gendersList);
        })

        const sueExpandedInsuranceTypesData = await generalModel.getExpandedInsuranceTypes();

        const sueTypesData = await suesModel.sueTypeGetAll();
        sueTypesData.sort((a: any, b: any) => (a.name > b.name) ? 1 : -1);
        setSueTypes(sueTypesData.map((st: any) => {
            return {
                label: st.name,
                policyTypeId: st.policyTypeId,
                value: st.id.toString()
            }
        }));
        const sueStatusesData = await suesModel.sueStatusGetAll();
        sueStatusesData.sort((a: any, b: any) => (a.name > b.name) ? 1 : -1);
        setSueStatuses(sueStatusesData.map((st: any) => {
            return {
                label: st.name,
                value: st.id.toString()
            }
        }));
        const sueActivityStatusesData = await suesModel.sueActivityStatusGetAll();
        sueActivityStatusesData.sort((a: any, b: any) => (a.name > b.name) ? 1 : -1);
        setSueActivityStatuses(sueActivityStatusesData.map((st: any) => {
            return {
                label: st.name,
                value: st.id.toString()
            }
        }));

        const sueApartmentTypesData = await generalModel.getApartmentSueTypes();
        const sueApartmentTypesList: any = [];
        Object.keys(sueApartmentTypesData).forEach((key: string) => {
            const sueApartmentTypeData = sueApartmentTypesData[key];
            sueApartmentTypesList.push({
                label: sueApartmentTypeData.description,
                value: sueApartmentTypeData.id.toString()
            })
        })
        setSueApartmentTypes(sueApartmentTypesList);

        const garagesListString = localStorage.getItem('garagesData');
        if (!garagesListString) {
            try {
                const garagesData: any[] = await manulApiModel.GetGarages();
                if (garagesData) {
                    setGarages([...garagesData]);
                    let moshahList =  garagesData.map((g: any) => ({
                            shem_mosah: g.shem_mosah,
                            id: g._id,
                            cod_miktzoa: g.cod_miktzoa,
                            cod_sug_mosah: g.cod_sug_mosah,
                            ktovet: g.ktovet,
                            menahel_miktzoa: g.menahel_miktzoa,
                            miktzoa: g.miktzoa,
                            mikud: g.mikud,
                            mispar_mosah: g.mispar_mosah,
                            rasham_havarot: g.rasham_havarot,
                            sug_mosah: g.sug_mosah,
                            telephone: g.telephone,
                            yishuv: g.yishuv
                    }));
                    localStorage.setItem('garagesData', JSON.stringify(moshahList));
                }
            } catch (error) {
                console.log('error', error)

            }
        } else {
            const garagesData = JSON.parse(garagesListString);
            setGarages(garagesData);
        }
        const insuranceCompaniesData = await simulatorModel.getInsuranceCompanies();
        const icTempDataKeys = Object.keys(insuranceCompaniesData);
        const fixedInsuranceCompanies: any[] = [];
        icTempDataKeys.forEach((k: string) => {
            fixedInsuranceCompanies.push({
                value: insuranceCompaniesData[k].description,
                label: insuranceCompaniesData[k].name,
                id: insuranceCompaniesData[k].description,
                name: insuranceCompaniesData[k].name,
            })
        });
        fixedInsuranceCompanies.sort((a: any, b: any) => (a.label > b.label) ? 1 : -1)
        setInsuranceCompanyList(fixedInsuranceCompanies);

        const suesOpenTabs = localStorage.getItem('suesOpenTabs');
        if (suesOpenTabs) {
            const tabs = JSON.parse(suesOpenTabs);
            setOpenTabs(tabs);
            // if (tabs && tabs.length > 0) {
            //     setSellectedSueId(tabs[0].id);
            //     setSelectedTabData(tabs[0]);
            // }
        }
    }

    const getSues = async (filter?: any) => {
        setLoading(true);
        setSuesList([]);
        if (!filter) {
            filter = suesFilter;
        }
        if (sortBy && !filter.sortBy) {
            filter.sortBy = [sortBy];
        }

        const filterKeys = Object.keys(filter);
        const filterParams: any[] = [];

        filterKeys.forEach((key: string) => {
            if (typeof filter[key] === 'undefined') return;
            const filterOption: any = {
                key: key,
                label: ''
            }
            let include = false;
            switch (key) {
                case 'sueStatusId': {
                    filterOption.label = 'סטטוס תביעה ';
                    const selected = sueStatuses.find((a: any) => a.value == filter.sueStatusId);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                case 'sueActivityStatusId': {
                    filterOption.label = 'מצב תביעה ';
                    const selected = sueActivityStatuses.find((a: any) => a.value == filter.sueActivityStatusId);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                case 'sueTypeId': {
                    filterOption.label = 'סוג תביעה ';
                    const selected = sueTypes.find((a: any) => a.value == filter.sueTypeId);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                case 'insuranceCompanyId': {
                    filterOption.label = 'חברה מבטחת';
                    if (filter.insuranceCompanyId === '-1') {
                        filterOption.value = 'פלוס שירותי דרך';
                        include = true;
                    } else {
                        const selected = insuranceCompanyList.find((a: any) => a.value == filter.insuranceCompanyId);
                        if (selected) {
                            filterOption.value = selected.label;
                            include = true;
                        }
                    }
                    break;
                }
                case 'thirdPartyInsuranceCompanyId': {
                    filterOption.label = 'חברת צ"ג';
                    if (filter.thirdPartyInsuranceCompanyId === '-1') {
                        filterOption.value = 'פלוס שירותי דרך';
                        include = true;
                    } else {
                        const selected = insuranceCompanyList.find((a: any) => a.value == filter.thirdPartyInsuranceCompanyId);
                        if (selected) {
                            filterOption.value = selected.label;
                            include = true;
                        }
                    }
                    break;
                }
                case 'defendantCompanyId': {
                    filterOption.label = 'חברה נתבעת ';
                    if (filter.defendantCompanyId !== '-1') {
                        const selected = insuranceCompanyList.find((a: any) => a.value == filter.defendantCompanyId);
                        if (selected) {
                            filterOption.value = selected.label;
                            include = true;
                        }
                    }
                    break;
                }
                case 'handlerId': {
                    filterOption.label = 'מטפל בתביעה';
                    const selected = handlersList.find((a: any) => a.value == filter.handlerId);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                case 'from': {
                    if (filter.dateType) {
                        filterOption.label = 'מ';
                        switch (filter.dateType) {
                            case 'OpeningDate': {
                                filterOption.label += 'תאריך פתיחה ';
                                break;
                            }
                            case 'ClosingDate': {
                                filterOption.label += 'תאריך סגירה ';
                                break;
                            }
                            case 'CreatedDate': {
                                filterOption.label += 'תאריך יצירה';
                                break;
                            }
                            case 'AccidentDateTime': {
                                filterOption.label += 'תאריך מקרה';
                                break;
                            }
                            default:
                                break;
                        }
                        filterOption.value = moment(filter.from).format('YYYY-MM-DD');
                        include = true;

                    }
                    break;
                }
                case 'to': {
                    filterOption.label = 'עד ';
                    if (filter.dateType) {
                        switch (filter.dateType) {
                            case 'OpeningDate': {
                                filterOption.label += 'תאריך פתיחה ';
                                break;
                            }
                            case 'ClosingDate': {
                                filterOption.label += 'תאריך סגירה ';
                                break;
                            }
                            case 'CreatedDate': {
                                filterOption.label += 'תאריך יצירה';
                                break;
                            }
                            case 'AccidentDateTime': {
                                filterOption.label += 'תאריך מקרה';
                                break;
                            }
                            default:
                                break;
                        }
                        filterOption.value = moment(filter.to).format('YYYY-MM-DD');
                        include = true;
                    }
                    break;
                }
                case 'vehiclePolicyType': {
                    filterOption.label = 'סוג ביטוח ';
                    filterOption.value = filter.vehiclePolicyTypeLabel ? filter.vehiclePolicyTypeLabel : '?'
                    include = true;
                    break;
                }
                case 'branchId': {
                    filterOption.label = 'סוכן ביטוח ';
                    filterOption.value = filter.branchIdLabel ? filter.branchIdLabel : '?'
                    include = true;
                    break;
                }
                case 'insuranceTypeIds': {
                    filterOption.label = 'סוג פוליסה ';
                    filterOption.value = filter.insuranceTypeIdLabel ? filter.insuranceTypeIdLabel : '?'
                    include = true;
                    break;
                }
                default:
                    break;
            }

            if (include && filterOption.value !== undefined) {
                filterParams.push(filterOption)
            }
        });
        setSelectedFilterOptions(filterParams)
        setFilterCount(filterParams.length.toString());


        // setShowOnlyRiders(false);
        if (filter.insuranceCompanyId < 0) {
            filter.insuranceCompanyId = undefined;
            setShowOnlyRiders(true);
        } else {
            setShowOnlyRiders(false);
        }
        const filterData: any = { ...filter };
        filterData.insuranceTypeIdLabel = undefined;
        filterData.branchIdLabel = undefined;
        filterData.vehiclePolicyTypeLabel = undefined;
        const signingsData = await suesModel.suesFilter(filterData);

        if (signingsData && signingsData.sues) {
            const newPageConf = {
                pageSize: signingsData.pageSize,
                currentPage: filter.page,
                totalItems: signingsData.allRowsCounter
            }
            setPagerConf(newPageConf);
            if (signingsData.sues && signingsData.sues.length && insuranceCompanyList.length > 0) {
                // const company = insuranceCompanyList.find()
                signingsData.sues.forEach((s: any) => {
                    if (s.route) {
                        const company = insuranceCompanyList.find((c: any) => c.value === s.route.insuranceCompanyId);
                        if (company) {
                            s.insuranceCompany = company;
                        }
                    }
                    if (typeof s.vehiclePolicyType !== 'undefined') {
                        const sInsuranceType: any = insuranceTypes.find((i: any) => i.id == s.vehiclePolicyType);
                        if (sInsuranceType) {
                            s.insuranceTypeLabel = sInsuranceType.name;
                        }
                    }
                    if (s.rider) {
                        const selectedRiderStatus = riderStatuses.find((rs: any) => rs.id === s.rider.riderStatusType);
                        if (selectedRiderStatus) {
                            s.rider.RiderStatusLabel = selectedRiderStatus.name;
                        }
                    }
                    if (s.sueTypeId && s.sueTypeId !== '') {
                        const selectedSueType = sueTypes.find((rs: any) => rs.value === s.sueTypeId.toString());
                        if (selectedSueType) {
                            s.sueTypeLabel = selectedSueType.label;
                        }
                    }
                    if (s.sueActivityStatusId && s.sueActivityStatusId !== '') {
                        const selectedSueActivityStatus = sueActivityStatuses.find((rs: any) => rs.value === s.sueActivityStatusId.toString());
                        if (selectedSueActivityStatus) {
                            s.activityStatusLabel = selectedSueActivityStatus.label;
                        }
                    }
                    if (s.sueStatusId && s.sueStatusId !== '') {
                        const selectedSueStatus = sueStatuses.find((rs: any) => rs.value === s.sueStatusId.toString());
                        if (selectedSueStatus) {
                            s.statusLabel = selectedSueStatus.label;
                        }
                    }
                    if (s.creatorUserId) {
                        const user = usersOptions && usersOptions.find((u: any) => u.id === s.creatorUserId);
                        if (user) {
                            s.creatorUser = user;
                        }
                    }
                });
            }
            setSuesList(signingsData.sues);
        }

        setLoading(false);
    }

    const buildOptionsForSelect = (source: any[], param: string = 'id', label: string = 'הכל') => {
        const items: any[] = [];
        source.forEach((i: any) => {
            items.push(
                {
                    label: i.fullName,
                    value: i[param]
                }
            );
        })
        return items;
    }

    const onPageChange = (page: number) => {
        if (page === 0) {
            page = 1;
        }
        const newConf = pagerConf;
        newConf.currentPage = page;
        setCurrentPage(page);
        setPagerConf(newConf);
        const newFilter = suesFilter;
        newFilter.page = page;
        setSuesFilter(newFilter);
        getSues(newFilter);
        // getTreatments(newFilter);
    }

    const setDataToLocalStorage = (key: string, value: any) => {
        const suesFilterData = localStorage.getItem('lastSuesFilter');
        let suesFilterObj: any = {};
        if (suesFilterData) {
            suesFilterObj = JSON.parse(suesFilterData);
            switch (key) {
                case 'searchTerm':
                    if (suesFilterObj.searchTerm !== value) {
                        suesFilterObj.searchTerm = value;
                        suesFilterObj.page = 1;
                        setCurrentPage(1);
                    }
                    break;
            }
        }
        suesFilterObj[key] = value;
        localStorage.setItem('lastSuesFilter', JSON.stringify(suesFilterObj));
    }


    const handleTreatmentSearchChange = async (event: any) => {
        const newSearchText = event.target.value;
        setTreatmentsSearchText(newSearchText);
        const newFilter = suesFilter;
        newFilter.searchTerm = newSearchText;
        setSuesFilter(newFilter);

        if (props.customerId && props.customerId.length > 0) {

        } else {
            setDataToLocalStorage('searchTerm', newSearchText);
        }

        clearTimeout(treatmentsTimeoutId);
        const newTimeoutId = setTimeout(() => {
            // getTreatments(newFilter);
        }, 1000);
        setTreatmentsTimeoutId(newTimeoutId);
    };

    const onShowDocumentPopUp = (url: string) => {
        setDocumentUrl(url);
    }

    const onHideDocumentPopUp = () => {
        setDocumentUrl(null);
    }

    const onHideSuesConfigPopUp = () => {
        setShowSuesConfigPopUp(false);
    }

    const doFilter = (filter?: any) => {
        let newFilter = filter ? filter : suesFilter;
        getSues(newFilter);
    }

    const exportToExcel = async () => {
        const filter = suesFilter;
        if (sortBy && !filter.sortBy) {
            filter.sortBy = [sortBy];
        }
        const exportData = await suesModel.exportSuesToExcel(filter);
        if (exportData && exportData.fileUrl) {
            window.open(exportData.fileUrl, '_blank');
        }
    }

    const clearSuesFliter = () => {
        setSuesFilter({
            page: 1,
        });
        setLastUpdate(moment().toDate());
        const newFilter: any = {
            page: 1,
            customerId: props.customerId ? props.customerId : undefined,
            searchTerm: undefined,
            userId: undefined,
            insuranceCompanyRouteId: undefined,
            dateType: undefined,
            branchId: undefined,
            from: undefined,
            to: undefined,
        };
        setSuesFilter(newFilter);
        setSelectedDateParam('0')
        setTreatmentsSearchText('');
        setSelectedInsuranceCompany('');
        setSelectedAgent('0');
        getSues(newFilter);
        setLastUpdate(moment().toDate());
        localStorage.removeItem('lastSuesFilter');
        if (filterCleaned) {
            dispatch(setFilterCleaned(false));
        } else {
            dispatch(setFilterCleaned(true));
        }
    }

    // signing function end

    const showHideAddTreatmentPopup = (show: boolean) => {
        setShowAddTreatmentPopUp(show);
    }

    const hideAddTreatmentPopup = () => {
        setShowAddTreatmentPopUp(false);
    }

    const showHideAddSubscriberPopup = (show: boolean) => {
        setShowAddSubscriberPopup(show);
    }


    ///////////


    const showAddTreatmentPopup2 = (type: number, customerId: string) => {
        setNewTreatmentType(type);
        setSellectedCustomerId(customerId);
        setShowAddTreatmentPopUp(true);
    }

    /////////////

    const showHideAddTreatmentPopup2 = (show: boolean, type: number) => {
        setNewTreatmentType(type);
        setShowAddTreatmentPopUp(show);
    }

    const closeMessagePopup = () => {
        setMessageContent(null);
    }
    const showMessagePopup = (message: string) => {
        if (message && message.length > 0) {
            setMessageContent(message);
        }
    }

    const onAddSubscriber = (customer: any, vehicle: any) => {
        if (customer) {
            if (customer.createdDate && typeof (customer.createdDate) === 'string') {
                customer.createdDate = moment(customer.createdDate);
            }
            if (customer.updatedDate && typeof (customer.updatedDate) === 'string') {
                customer.updatedDate = moment(customer.updatedDate);
            }
            if (customer.driverLicensIssueDate && typeof (customer.driverLicensIssueDate) === 'string') {
                customer.driverLicensIssueDate = moment(customer.driverLicensIssueDate);
            }
            if (customer.identityIssueDate && typeof (customer.identityIssueDate) === 'string') {
                customer.identityIssueDate = moment(customer.identityIssueDate);
            }
            // identityIssueDate
            // driverLicensIssueDate
            // updatedDate
        }
        setSelectedCustomer(customer);
        setSelectedVehicle(vehicle);
        showHideAddSubscriberPopup(true);

    }

    const onSortChange = async (property: string) => {
        let currentSort: any = sortBy ? { ...sortBy } : {
            property: "createdDate",
            SortDirection: ""
        };

        const filter = suesFilter;
        if (currentSort.property == property && sortBy && sortBy.SortDirection == 'DESC') {
            await setSortBy(undefined);
            filter.sortBy = undefined;
        } else {
            if (currentSort.property == property && sortBy) {
                currentSort.SortDirection = sortBy.SortDirection == 'ASC' ? 'DESC' : 'ASC'
            } else {
                currentSort.SortDirection = 'ASC';
                currentSort.property = property;
            }
            await setSortBy(currentSort);
            filter.sortBy = [currentSort];
        }
        getSues(filter);
    }

    const onRelaodAfterSaveSue = async (data: any) => {
        doFilter();

        setPopUpTitle('התביעה נשמרה בהצלחה');
        setShowPopup(true);
        // if (data && data.id) {
        //     await showSueTab(data.id);
        //
    }

    const closeTab = (id: string, e?: Event) => {
        if (e) {
            e.preventDefault();
        }
        let currentTabs = [...openTabs];
        currentTabs = currentTabs.filter((m: any) => m.id !== id);
        updateOpenTabs(currentTabs);
        if (sellectedSueId == id) {
            setSellectedSueId(null);
            setSelectedTabData(null);
        }
        setLastUpdate(moment().toDate());

    }

    const updateOpenTabs = (tabs: any) => {
        console.log('updateOpenTabs-tabs', tabs)

        setOpenTabs(tabs);
        const tabsForSave: any[] = [];
        tabs.forEach((tab: any) => {
            const tContent: any = {
                type: tab.type,
                title: tab.title,
                id: tab.id,
                mode: tab.mode,
                editData: tab.editData ? tab.editData : undefined,
                loaded: false
            }
            if (tab.editData && typeof tab.editData !== 'undefined') {
                tContent.editData = tab.editData;
            }
            tabsForSave.push(tContent);
        });
        console.log('updateOpenTabs-tabsForSave', tabsForSave)
        localStorage.setItem('suesOpenTabs', JSON.stringify(tabsForSave));
        // localStorage.setItem('clientsOpenTabs', JSON.stringify(tabsForSave));
    }

    const showSueTab = (id: string) => {
        showSigning(id);
    }


    const showSigningSList = () => {
        setSellectedSueId(null);
    }

    const showSigning = async (id: string, mode: ViewMode = ViewMode.VIEW) => {

        if (!props.showTabs) {
            if (props.onClaimEdit) {
                props.onClaimEdit(id, { sueId: id })
            }
            return;
        }
        await setSellectedSueId(null);
        await setSelectedTabData(null);
        console.log('showSigning-openTabs', openTabs)
        let tabContent = openTabs.find((m: any) => m.id == id);

        let viewMode: ViewMode = mode;
        if (tabContent) {
            viewMode = tabContent.mode;
        }

        if (!tabContent || (tabContent.mode != ViewMode.ADD && !tabContent.loaded)) {
            const tabIsExists = tabContent ? true : false;
            setLoading(true);
            const selectedItem = await suesModel.suesGetById({ sueId: id });
            console.log('showSigning-selectedItem', selectedItem)
            if (selectedItem) {
                let currentTabs = [...openTabs];
                console.log('showSigning-currentTabs', currentTabs)
                tabContent = {
                    type: 'editSue',
                    id: id,
                    title: selectedItem.customer ? selectedItem.customer.fullName : 'ללא שם',
                    loaded: true,
                    sueData: selectedItem,
                    genders: gendersList,
                    statuses: policyStatuses,
                    vehicleOwnerships: vehicleOwnerships
                }
                let tabeExists = currentTabs.find((m: any) => m.id == tabContent.id);
                if (!tabeExists) {
                    currentTabs.push(tabContent);
                }
                console.log('showSigning-currentTabs-after', currentTabs)
                updateOpenTabs(currentTabs);
                setLastUpdate(moment().toDate());
            }
            setLoading(false);
        }
        setSellectedSueId(id);
        setSelectedTabData(tabContent);
    }

    const toggleShowAdvancedSearch = (newValue?: boolean) => {
        if (!newValue) {
            newValue = showAdvancedSearch;
            setShowAdvancedSearch(!newValue)
        } else {
            setShowAdvancedSearch(newValue)
        }
    }

    const onAdvancedSearchApprove = (newFilter: any) => {
        setSuesFilter(newFilter);
        getSues(JSON.parse(JSON.stringify(newFilter)));
        toggleShowAdvancedSearch(false);
    }

    const onAdvancedSearchClear = () => {
        clearSuesFliter();
        toggleShowAdvancedSearch(false);
    }

    const onAssignToHandlerClick = (id: string) => {
        setSigningIdToAssign(id);
        setShowAssignToHandlerPopUp(true);
    }

    const onSigningUpdate = async (newData: any, index?: number) => {
        // saveDataProduction
        // newData.offer = null;
        await elementaryPolicyStatusModel.signingUpdate(newData);
    }

    const addSueComment = async (commentData: any, signingId: string) => {
        await suesModel.sendSueComment(commentData);
    }


    const onPolicyUpdate = async (newData: any) => {
        newData.offer = null;
        await offerProductionModel.saveDataProduction(newData);
    }

    const onPolicyFileDelete = async (fileId: string) => {
        await offerProductionModel.deleteFile(fileId);
    }

    const onRemoveFilterOption = (key: string) => {
        const newList = selectedFilterOptions.filter((i: any) => i.key !== key);
        setSelectedFilterOptions(newList);
        const newFilter = suesFilter;
        newFilter[key] = undefined;
        if (key == 'insuranceCompanyRouteId') {
            newFilter.insuranceCompanyRouteLabel = undefined;
        }
        if (key == 'underwriterUserId') {
            newFilter.underwriterType = undefined;
        }
        if (key == 'creatorUserId') {
            newFilter.createdBy = undefined;
        }
        setSuesFilter(newFilter);
        doFilter(newFilter);
    }

    const hideSigningConfigPopup = () => {
        setShowSigningConfigPopup(false)
    }


    const emptyFunc = (t?: any, v?: any) => { }


    useEffect(() => {
        init()
    }, [])


    useEffect(() => {
        const savedLoggedUser = localStorage.getItem('loggedUser');
        let loggedUser: any = {}
        if (savedLoggedUser) {
            loggedUser = JSON.parse(savedLoggedUser);
            setCurrentUser(loggedUser);
        }
    }, [userLogged])

    useEffect(() => {
        if (insuranceCompanyList && insuranceCompanyList.length > 0) {
            getSues();
        }

    }, [insuranceCompanyList])

    useEffect(() => {
        if (reloadSuesData) {
            getSues();
            dispatch(setReloadSuesData(false))
        }
    }, [reloadSuesData])

    useEffect(() => {
        if (popUpTreatmentSuesModel.show) {
            showHideAddTreatmentPopup2(popUpTreatmentSuesModel.show, popUpTreatmentSuesModel.type)
        }

    }, [popUpTreatmentSuesModel])

    const showHidePopup = (show: boolean) => {
        setShowPopup(show);
    }

    const hasPermission = () => {
        const loggedUserString = localStorage.getItem('loggedUser');
        if (loggedUserString) {
            const loggedUser = JSON.parse(loggedUserString);
            if (loggedUser && (loggedUser.role == 0 || loggedUser.role == 10)) {
                return true;
            }
        }
        return false;
    }

    return (
        <div className={`main-content clients-main-content rtl ${props.showTabs ? 'show-tabs' : 'no-tabs'}`}>
            {
                loading && (
                    <PleaseWaitLayer />
                )
            }
            {
                documentUrl && (
                    <LeadDocumentPopup
                        ClosePopup={onHideDocumentPopUp}
                        documentUrl={documentUrl}
                    />
                )
            }

            {
                showSuesConfigPopUp &&
                <SuesConfigPopup
                    ClosePopup={onHideSuesConfigPopUp}
                    config={{}}
                    messageTitle={'הגדרות'}
                />
            }

            {
                showAddTreatmentPopUp &&
                <ClientAddTreatmentPopup
                    // messageTitle={newTreatmentType.toString()}
                    ShowHidePopup={showHideAddTreatmentPopup}
                    type={newTreatmentType}
                    ClosePopup={() => hideAddTreatmentPopup()}
                    customerId={sellectedCustomerId ? sellectedCustomerId : ''}
                />
            }

            {
                showPopUp &&
                <ClientPopup
                    messageTitle={popUptitle}
                    messageContent={""}
                    ShowHidePopup={showHidePopup}
                    ClosePopup={() => showHidePopup(false)}
                />
            }


            {showAddSubscriberPopUp && (
                <>
                    <SubscriberPopup
                        id={''}
                        customer={selectedCustomer}
                        vehicle={selectedVehicle}
                        actionType={undefined}
                        rider={selectedTabData.sueData.rider ? selectedTabData.sueData.rider : undefined}
                        ClosePopup={() => showHideAddSubscriberPopup(false)}
                        OpenPayment={() => showHideAddSubscriberPopup(false)}
                    />
                </>
            )
            }

            {messageContent &&
                <LeadMessagePopup
                    ClosePopup={() => closeMessagePopup()}
                    messageContent={messageContent}
                    messageTitle={'שגיאה'}
                />
            }

            {props && props.showTabs && <Menu activePage='Claims' />}
            <div className="center-content">
                {props && props.showTabs && <>
                    <Header PageName="תביעות" />
                    <section className="page-tab-row">
                        <div className="emails-tab-row">
                            <div className={`email-tab email-tab-clients selected`} onClick={emptyFunc}>
                                <div className="top-border"></div>
                                <div className="tab-content">
                                    <div className="label" onClick={showSigningSList}>
                                        תביעות
                                    </div>
                                </div>
                            </div>
                            {openTabs.map((m: any) => {
                                return (
                                    <div className={`email-tab email-tab-view-message email-tab-${m.id} ${sellectedSueId == m.id ? 'selected' : ''}`} key={m.id}>
                                        <div className="top-border"></div>
                                        <div className="tab-content">
                                            <div className="label" onClick={() => showSueTab(m.id)}>
                                                {m.title}
                                            </div>
                                            {/* <div className="icon-holder pointer">
                                                <div className="icon x-close-grey" onClick={(e: any) => closeTab(m.id, e)}></div>
                                            </div> */}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </section>
                </>
                }
                <section className={`page-tab-content all-clients ${sellectedSueId == null ? 'selected' : ''}`} id="all-clients">
                    <div className="content-header">
                        <div className="flex-end desktop-only clients-search-row client-list-search client-list-view">
                            <div className="list-actions-row flex-centered flex-space-between">
                                <div className="filter-row flex-centered client-search">
                                    <div>
                                        <div className="filter-input search">
                                            <input type="text" value={treatmentsSeachText} placeholder="חיפוש" onChange={handleTreatmentSearchChange}
                                                onKeyDown={(e: any) => {
                                                    if (e.key === 'Enter') { doFilter(); }
                                                }} />

                                        </div>
                                    </div>
                                    <div className="filter-button">
                                        <Popover
                                            placement="bottom"
                                            content={
                                                props.customerId ? <AdvancedClientSuesFilter
                                                    filter={suesFilter}
                                                    policyTypes={policyTypes}
                                                    productionTypes={productionTypes}
                                                    onHide={() => toggleShowAdvancedSearch(false)}
                                                    onApprove={onAdvancedSearchApprove} onClear={onAdvancedSearchClear}
                                                /> :
                                                    <AdvancedSuesSearch
                                                        filter={suesFilter}
                                                        policyTypes={policyTypes}
                                                        productionTypes={productionTypes}
                                                        onHide={() => toggleShowAdvancedSearch(false)}
                                                        onApprove={onAdvancedSearchApprove} onClear={onAdvancedSearchClear} />

                                            }
                                            title=""
                                            trigger="click"
                                            open={showAdvancedSearch}
                                            onOpenChange={toggleShowAdvancedSearch}
                                        >
                                            <button className="act-btn has-icon" onClick={(e: any) => emptyFunc()}>
                                                <div className="icon sliders"></div>
                                                מסננים - {filterCount}
                                            </button>
                                        </Popover>
                                    </div>
                                    <div className='flex-start flex-centered filter-option-list'>
                                        {selectedFilterOptions && selectedFilterOptions.map((fo: any, index: number) => {
                                            return <div className='filter-selected-option' key={index}>
                                                <div className='option'>
                                                    <div className='label'>{fo.label}:</div> {fo.value === true ? <FontAwesomeIcon icon={faCheck} /> : <div className='value'>{fo.value}</div>}</div>
                                                <div className="icon-holder pointer" onClick={() => onRemoveFilterOption(fo.key)}>
                                                    <div className="icon x-close-grey"></div>
                                                </div>
                                            </div>
                                        })}
                                    </div>

                                    <div className="filter-button">
                                        <button className="act-btn" onClick={() => doFilter()}>הצג דוח</button>
                                    </div>
                                    <div className="filter-button">
                                        <button className="act-btn" onClick={clearSuesFliter}>נקה בחירה</button>
                                    </div>
                                    {hasPermission() &&
                                        <div className="filter-button">
                                            <button className="act-btn" onClick={exportToExcel}>יצוא לאקסל</button>
                                        </div>
                                    }
                                </div>
                                <div className="cliets-main-buttons">

                                    {/* <div className="icon print pointer"></div>
                                    <div className="icon excel pointer"></div> */}

                                    {/* <button type="button" className="button blue has-icon flex-centered flex-justify-center" onClick={()=>emptyFunc()}>
                                        <div className="icon add"></div>
                                        הוסף
                                    </button> */}
                                    {props.showTabs && <div className="icon icon-config gear pointer" onClick={() => setShowSuesConfigPopUp(true)}></div>}
                                </div>
                            </div>
                        </div>
                    </div>

                    <SuesTable
                        data={suesList ? suesList : []}
                        statuses={policyStatuses ? policyStatuses : []}
                        sortBy={sortBy}
                        className='big'
                        showOnlyRiders={showOnlyRiders}
                        config={{
                            users: usersOptions
                        }}
                        fromClient={props.customerId ? true : false}
                        actions={{
                            edit: (id: string) => emptyFunc(),
                            update: (data: any, index?: number) => onSigningUpdate(data, index),
                            sendEmail: (id: string) => emptyFunc(),
                            sendWhatsApp: (id: string) => emptyFunc(),
                            print: (id: string) => emptyFunc(),
                            setStatus: (id: string, newStatus: string) => emptyFunc(),
                            delete: (id: string) => emptyFunc(id),
                            onSortChange: (property: string) => onSortChange(property),
                            onShowDocument: (url: string) => onShowDocumentPopUp(url),
                            // onSelectSigning: (id: string)=> showSueTab(id),
                            addSigningComment: (commentData: any, signingId: string) => addSueComment(commentData, signingId),
                            showAddTreatmentPopup: (type: number, customerId: string) => showAddTreatmentPopup2(type, customerId)
                        }}
                        onSelectSigning={(id: string) => showSigning(id)}
                    />

                    <footer className="footer emails-list-footer emails-list-view">
                        <Pagger pagerConf={pagerConf} changePage={onPageChange} refresh={emptyFunc}></Pagger>
                    </footer>
                </section>
                {sellectedSueId != null && props.showTabs ? (
                    <section className={`page-tab-content ${sellectedSueId != null ? 'selected' : ''}`}>
                        <SueDetails
                            onRelaodAfterSaveSue={(data: any) => onRelaodAfterSaveSue(data)}
                            customerId={sellectedSueId}
                            tabData={selectedTabData}
                            setLoading={setLoading}
                            updateEditData={(data: any, index?: number) => onSigningUpdate(data, index)}
                            updatePolicy={(data: any) => onPolicyUpdate(data)}
                            addSigningComment={(commentData: any) => addSueComment(commentData, sellectedSueId)}
                            onFileDelete={(fileId: string) => onPolicyFileDelete(fileId)}
                            updateMode={emptyFunc}
                            config={{
                                sueStatuses: sueStatuses,
                                sueActivityStatuses: sueActivityStatuses,
                                sueTypes: sueTypes,
                                insuranceTypes: insuranceTypes,
                                licenseTypes: licenseTypes,
                                sueApartmentTypes: sueApartmentTypes,
                                handlers: handlersList,
                                genders: gendersList,
                                insuranceCompanies: insuranceCompanyList,
                                garages: garages,
                                vehicleOwnerships: vehicleOwnerships,
                                users: usersOptions,
                                showAddTreatmentPopup: (type: number, customerId: string) => showAddTreatmentPopup2(type, customerId),
                                closeTab: () => closeTab(sellectedSueId),
                                showMessagePopup: (message: string) => showMessagePopup(message)
                            }}

                        />
                    </section>
                ) : (
                    <></>
                )
                }


            </div>
        </div>
    )
}
export default Sues;